import { JSX, useState } from "react";
import TopProcedure from "./TopProcedure";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

interface TopProceduresProps {
  containerClassName?: string,
  disabled: boolean,

  /**
   * List of top conditions to display in the dropdown
   */
  topProcedures: DropdownItem<TopProcedure>[];

  onSelectionChanged?: (selectedTopProcedures: DropdownItem<TopProcedure>[]) => void;
  selectedTopProcedures: DropdownItem<TopProcedure>[];
  setSelectedTopProcedures: (selectedTopProcedures: DropdownItem<TopProcedure>[]) => void;
  testId: string;
  title: string;
}

const TopProcedureFilter = (props: TopProceduresProps): JSX.Element => {

  const [searchText, setSearchText] = useState("");
  const [filteredTopProcedures, setFilteredTopProcedures] = useState<DropdownItem<TopProcedure>[]>([]);

  /**
   * Handler for when the search text in the top conditions dropdown changes
   * @param searchText - The new search text
   */
  const onSearchTextChange = (searchText: string) => {
    setSearchText(searchText);
    const filtered = searchText === "" ? [] : props.topProcedures.filter(option =>
      option.name.toLowerCase().includes(searchText.toLowerCase()));
    setFilteredTopProcedures(filtered);
  };

  return (
    <MultiselectDropdown
      containerClassName={props.containerClassName ?? "d-block"}
      customSelectInputText={null}
      disabled={props.disabled}
      items={!!searchText ? filteredTopProcedures : props.selectedTopProcedures.concat(filteredTopProcedures)}
      onSelectionChanged={(selectedValues: DropdownItem<TopProcedure>[]) => { props.setSelectedTopProcedures(selectedValues) }}
      onSearchTextChange={onSearchTextChange}
      label={props.title}
      selectedItems={props.selectedTopProcedures}
      testId={props.testId}
      hideSelectAll={true}
      showTooltipOnOverflow={true}
      validationTooltipContent={"This dropdown searches the top 5 procedure codes across all available lines of business, regardless of your current filters."}
      autofocusSearch={true}
    />
  )
}

export default TopProcedureFilter;